import React from "react";
import { DropdownButton } from "@jsq/ds/core";
import { PAYMENT_INSTRUCTIONS_LABEL } from "./constants";
import * as styles from "./styles_vanilla.css";
import { type PaymentPrefActionsProps } from "./types";

export const PaymentPrefActions: React.FC<PaymentPrefActionsProps> = ({
  switchPaymentMethodCallback,
  editPaymentInstructionsCallback,
  deletePaymentInstructionsCallback,
  paymentMethod,
}) => {
  return (
    <DropdownButton
      data-testid="payment-pref-action-trigger"
      variant="muted"
      align="right"
      direction="down"
      icon="ellipsis-h"
      className={styles.actionsButton}
    >
      <DropdownButton.Action onSelect={() => editPaymentInstructionsCallback()}>
        Edit {PAYMENT_INSTRUCTIONS_LABEL[paymentMethod]} instructions
      </DropdownButton.Action>
      <DropdownButton.Action onSelect={() => deletePaymentInstructionsCallback()}>
        Delete payment instructions
      </DropdownButton.Action>
      <DropdownButton.Action onSelect={() => switchPaymentMethodCallback()}>
        Switch payment method
      </DropdownButton.Action>
    </DropdownButton>
  );
};
